import { BrowserRouter, Route, Routes } from "react-router-dom"
import { getAPIHeaders, getEndpointFromConfig } from "../common/utils/helper"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import {
  setAPIKeyName,
  setAPIKeyValue,
  setCountryList,
  setEndpointList,
  setPageName,
  setFeatureProps,
  setGrouping,
  setHierarchyData,
} from "../common/commonSlice"
import fetchData from "../service/apiService"
import { endpointLabels } from "../common/utils/enum"
import { COUNTRY_GROUPINGS } from "../common/utils/constants"
import IndicatorProfileWrapper from "../components/IndicatorProfileWrapper"
import IndicatorProfileWithFiltersWrapper from "../components/indicatorProfileWithFilters/IndicatorProfileWithFiltersWrapper"
import appConfig from "../config/appConfig"
import { setIndicatorProfileCountryHierarchy } from "../components/indicatorProfileSlice"
import "../assets/styles/index.css"

function App() {
  const dispatch = useDispatch()
  const { indicatorMetadata, isIndicatorMetadataCompleted } = useSelector(
    (state) => state.indicatorProfile,
  )

  const featureProps = appConfig

  dispatch(setFeatureProps(featureProps))
  useEffect(() => {
    dispatch(setEndpointList(featureProps.endpointList))
    dispatch(setPageName(featureProps.name))
    if (featureProps.apiKeyName) {
      dispatch(setAPIKeyName(featureProps.apiKeyName))
    }
    if (featureProps.apiKeyValue) {
      dispatch(setAPIKeyValue(featureProps.apiKeyValue))
    }
  }, [])

  useEffect(() => {
    const indicatorName = indicatorMetadata?.series_description?.name
    if (isIndicatorMetadataCompleted && indicatorName) {
      document.title = `${featureProps.headerTitle} | ${indicatorName} | ${featureProps.brandSlug}`
    }
  }, [isIndicatorMetadataCompleted])

  useEffect(() => {
    const getHierarchyData = async () => {
      try {
        const apiHeaders = getAPIHeaders({
          apiKeyName: featureProps?.apiKeyName,
          apiKeyValue: featureProps?.apiKeyValue,
        })
        const response = await fetchData(
          getEndpointFromConfig(
            featureProps.endpointList,
            endpointLabels.Hierarchy,
          ).apiEndpoint,
          "GET",
          null,
          apiHeaders,
        )
        if (response?.Hierarchy) {
          const hierarchyData = response?.Hierarchy[0]

          dispatch(setHierarchyData(hierarchyData))
        }
      } catch (error) {
        console.log("error hierarchy", error)
      }
    }

    getHierarchyData()

    const fetchGroupings = async () => {
      try {
        const apiHeaders = getAPIHeaders({
          apiKeyName: featureProps?.apiKeyName,
          apiKeyValue: featureProps?.apiKeyValue,
        })

        const countriesMapping = await fetchData(
          getEndpointFromConfig(
            featureProps.endpointList,
            endpointLabels.Grouping,
          ).apiEndpoint,
          "GET",
          null,
          apiHeaders,
        )
        const groupings = Object.fromEntries(
          Object.entries(countriesMapping?.data || {}).filter(([key]) =>
            COUNTRY_GROUPINGS.includes(key),
          ),
        )
        dispatch(setGrouping(groupings))
        dispatch(
          setIndicatorProfileCountryHierarchy(
            countriesMapping?.data?.HCL_REF_AREA || {},
          ),
        )

        let countryList = []
        if (groupings["HCL_WB_REGIONS"]) {
          countryList = groupings["HCL_WB_REGIONS"].map(
            (item) => item.countries,
          )
          countryList = countryList.flat()
          const uniqueMap = new Map()

          countryList.forEach((country) => {
            if (!uniqueMap.has(country.id)) {
              uniqueMap.set(country.id, country)
            }
          })

          countryList = Array.from(uniqueMap.values())
        }

        if (countryList.length > 0) {
          dispatch(setCountryList(countryList))
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }
    fetchGroupings()
  }, [])

  return (
    <BrowserRouter basename="/data360">
      <Routes>
        <Route
          path="/advancedembed"
          element={<IndicatorProfileWithFiltersWrapper />}
        />
        <Route
          path="/embed"
          element={<IndicatorProfileWrapper />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
